import styled from 'styled-components';

import MaterialIcon from '@/components/atom/MaterialIcon';
import DNSearchBar, {
  DNSearchBarProps,
} from '@/designComponents/organisms/DNSearchBar';
import { historyBack } from '@/utils/mobile/RNPlugins';

type DNSearchHeaderProps = DNSearchBarProps;
const DNSearchHeader = ({ ...props }: DNSearchHeaderProps) => {
  return (
    <SearchBarWrapper id={'appHeader'}>
      <IconWrapper onClick={historyBack}>
        <MaterialIcon name={'arrow_back_ios_new'} />
      </IconWrapper>
      <DNSearchBar {...props} />
    </SearchBarWrapper>
  );
};

export default DNSearchHeader;

const SearchBarWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 6px 24px 6px 0;

  ${({ theme }) => `
    height: ${theme.size.appHeader.height};
    background: ${theme.color.white};
  `};
`;

const IconWrapper = styled.button`
  margin: 0 16px;
  padding: 2px;
  border-radius: 8px;

  ${({ theme }) => `
    &: hover {
      background: ${theme.color.gray30};
    };
    &: active {
      background: ${theme.color.gray50};
    }
  `};
`;
